import ApontamentoContent from "./ApontamentoContent";

export default function Apontamento() {
  return <ApontamentoContent />;
}
